const riot = require('riot');

riot.tag2('module-calendar', '<div class="relative s-full"> <div class="f fm gap-10 mb20"> <div data-is="atom-google-preview-switch"></div> <div class="{isLoad ? &quot;load-animation&quot; : &quot;&quot;}" show="{showReloadButton}" data-is="atom-reload-button"></div> </div> <div class="calendar-height" ref="calendar"></div> </div>', 'module-calendar,[data-is="module-calendar"]{display:block} module-calendar .fc-timegrid-event-harness,[data-is="module-calendar"] .fc-timegrid-event-harness,module-calendar .fc-daygrid-event-harness,[data-is="module-calendar"] .fc-daygrid-event-harness{background-color:white;border-radius:8px} module-calendar .fc-event,[data-is="module-calendar"] .fc-event{overflow:hidden} module-calendar .fc-event-main,[data-is="module-calendar"] .fc-event-main{overflow:hidden;padding:0 8px} module-calendar .fc-event-title,[data-is="module-calendar"] .fc-event-title{white-space:pre-line} module-calendar .fc-timeGridDay-view .fc-day-today,[data-is="module-calendar"] .fc-timeGridDay-view .fc-day-today{background-color:white !important} module-calendar .fc-day-today,[data-is="module-calendar"] .fc-day-today{background-color:rgba(162,0,25,0.05) !important} module-calendar .fc-day-today.fc-popover,[data-is="module-calendar"] .fc-day-today.fc-popover{background-color:white !important} module-calendar .fc-day.fc-col-header-cell,[data-is="module-calendar"] .fc-day.fc-col-header-cell{padding:12px} module-calendar .fc-daygrid-day.fc-day.fc-day-today,[data-is="module-calendar"] .fc-daygrid-day.fc-day.fc-day-today,module-calendar .fc-timegrid-col.fc-day.fc-day-today,[data-is="module-calendar"] .fc-timegrid-col.fc-day.fc-day-today{color:#444 !important;font-size:16px} module-calendar .fc .fc-daygrid-day-top,[data-is="module-calendar"] .fc .fc-daygrid-day-top{justify-content:center} module-calendar .fc-timegrid-slots .fc-timegrid-slot,[data-is="module-calendar"] .fc-timegrid-slots .fc-timegrid-slot{font-size:10px;height:20px} module-calendar .fc-timegrid-slots tr:not(:nth-child(4n)) td,[data-is="module-calendar"] .fc-timegrid-slots tr:not(:nth-child(4n)) td{border-bottom:1px solid transparent} module-calendar .fc-daygrid-event-harness,[data-is="module-calendar"] .fc-daygrid-event-harness{margin-top:0px !important} module-calendar .fc-toolbar-chunk,[data-is="module-calendar"] .fc-toolbar-chunk{display:flex} module-calendar .fc-toolbar-title,[data-is="module-calendar"] .fc-toolbar-title{margin:0px 0px 0px 10px !important} module-calendar .fc-button:focus,[data-is="module-calendar"] .fc-button:focus{box-shadow:none !important} module-calendar .fc-button:disabled,[data-is="module-calendar"] .fc-button:disabled{color:#A20019 !important;border:1px solid #A20019 !important} module-calendar .fc-custom_today-button,[data-is="module-calendar"] .fc-custom_today-button{border:1px solid #A20019 !important;background-color:white !important;color:#A20019 !important;padding:7px 12px;font-size:12px;transition:256ms;cursor:pointer} module-calendar .fc-custom_today-button:hover,[data-is="module-calendar"] .fc-custom_today-button:hover{background-color:#F7F7F8 !important} module-calendar .fc-custom_today-button:active,[data-is="module-calendar"] .fc-custom_today-button:active{background-color:rgba(162,0,25,0.4) !important;color:#A20019 !important} module-calendar .fc-icon_calendar-button,[data-is="module-calendar"] .fc-icon_calendar-button{background-color:transparent !important;padding:0;border:none;color:#2E2E38 !important;font-size:24px;margin-left:8px !important} module-calendar .fc-timeGridDay-button,[data-is="module-calendar"] .fc-timeGridDay-button,module-calendar .fc-timeGridWeek-button,[data-is="module-calendar"] .fc-timeGridWeek-button,module-calendar .fc-dayGridMonth-button,[data-is="module-calendar"] .fc-dayGridMonth-button{border:1px solid #EBEBF0;background-color:white;color:#2E2E38;padding:7px 18px;font-size:12px;transition:256ms} module-calendar .fc-timeGridDay-button:hover,[data-is="module-calendar"] .fc-timeGridDay-button:hover,module-calendar .fc-timeGridWeek-button:hover,[data-is="module-calendar"] .fc-timeGridWeek-button:hover,module-calendar .fc-dayGridMonth-button:hover,[data-is="module-calendar"] .fc-dayGridMonth-button:hover{border:1px solid #EBEBF0 !important;background:rgba(162,0,25,0.1) !important;color:#A20019 !important} module-calendar .fc-timeGridDay-button.fc-button-active,[data-is="module-calendar"] .fc-timeGridDay-button.fc-button-active,module-calendar .fc-timeGridWeek-button.fc-button-active,[data-is="module-calendar"] .fc-timeGridWeek-button.fc-button-active,module-calendar .fc-dayGridMonth-button.fc-button-active,[data-is="module-calendar"] .fc-dayGridMonth-button.fc-button-active{border:1px solid #EBEBF0 !important;background:rgba(162,0,25,0.1) !important;color:#A20019 !important} module-calendar .fc-prev-button,[data-is="module-calendar"] .fc-prev-button,module-calendar .fc-next-button,[data-is="module-calendar"] .fc-next-button{border:none !important;background-color:white;border-radius:50%;width:32px;height:32px;display:flex;justify-content:center;align-items:center;color:#2E2E38;transition:256ms} module-calendar .fc-prev-button:hover,[data-is="module-calendar"] .fc-prev-button:hover,module-calendar .fc-next-button:hover,[data-is="module-calendar"] .fc-next-button:hover{background-color:#F7F7F8 !important;color:#2E2E38} module-calendar .fc-prev-button:active,[data-is="module-calendar"] .fc-prev-button:active,module-calendar .fc-next-button:active,[data-is="module-calendar"] .fc-next-button:active{background-color:#F7F7F8 !important;color:#2E2E38 !important} module-calendar .fc-timegrid-now-indicator-line,[data-is="module-calendar"] .fc-timegrid-now-indicator-line{pointer-events:none;border-color:#A20019;border-width:2px 0 0} module-calendar .fc-timegrid-now-indicator-line::before,[data-is="module-calendar"] .fc-timegrid-now-indicator-line::before{content:\'\';position:absolute;display:flex;justify-content:left;background-image:url(/images/indicator_content.svg);background-size:contain;background-repeat:no-repeat;bottom:-5px;width:12px;height:12px} module-calendar .fc-timegrid-now-indicator-arrow,[data-is="module-calendar"] .fc-timegrid-now-indicator-arrow{display:none}@media only screen and (max-width:600px){ module-calendar .fc-toolbar-title,[data-is="module-calendar"] .fc-toolbar-title{font-size:22px}} module-calendar .fc-day-sat,[data-is="module-calendar"] .fc-day-sat{color:#3752be} module-calendar .fc-day-sun,[data-is="module-calendar"] .fc-day-sun{color:#da5d3c} module-calendar .load-animation,[data-is="module-calendar"] .load-animation{animation:1.5s infinite load}@keyframes load{ from{transform:rotate(0deg)} to{transform:rotate(360deg)}} module-calendar .calendar-height,[data-is="module-calendar"] .calendar-height{height:calc(100% - 42px)}', '', function(opts) {
    this.showReloadButton = false;
    this.isLoad = false;

    this.on('mount', () => {

      this.tags['atom-google-preview-switch'].on('toggle', async (enabled) => {

        this.showReloadButton = enabled;
        this.isLoad = true;
        this.update();

        if (enabled) {
          await this.previewEvents();
        }
        else {
          this.calendar.batchRendering((info) => {
            this.clearPreviewEvents();
          });
        }

        this.isLoad = false;
        this.update();
      });

      this.tags['atom-reload-button'].on('click', async () => {
        this.isLoad = true;
        this.update();
        this.calendar.batchRendering((info) => {
          this.clearPreviewEvents();
        });
        await this.previewEvents();
        this.isLoad = false;
        this.update();
      });
    });

    this.previewEvents = async () => {
      let data = await app.gCalendar.listUpcomingEvents();

      data.schedules.forEach((schedule) => {
        let organizedSchedule = {
          title: schedule.summary,
          project: '',
          project_ref: null,
          tags:[],
          is_recording: false,
          start_at: dayjs(schedule.start.dateTime).valueOf(),
          end_at: dayjs(schedule.end.dateTime).valueOf(),
          is_preview: true,
        };
        this.recordToEvent({ data:organizedSchedule });
      });
    }

    this.clearPreviewEvents = async () => {

      let previewEvents = this.calendar.getEvents().filter(event => event.extendedProps.record.data.is_preview);
      previewEvents.forEach((event) => {
        event.remove();
      });
    }

    this.setup = () => {
      if (this.calendar && !app.useragent.isMobile) {
        this.calendar.render();
        return;
      }

      var view_type = this.getViewType();

      var calendar = new FullCalendar.Calendar(this.refs.calendar, {
        locale: 'ja',
        initialView: app.useragent.isMobile ? 'timeGridDay' : view_type,
        initialDate: dayjs().format('YYYY-MM-DD'),
        droppable: true,
        editable: true,
        eventResizableFromStart: true,
        eventDisplay: 'block',
        selectable: true,
        scrollTime: '08:00:00',
        nowIndicator: true,
        navLinks: true,

        dayHeaderContent: (info) => {

          const date = new Date(info.date);

          const holiday_label = this.getHolidayLabel(date);

          let date_text = `<div class="${this.isHoliday(date) ? 'text-alert_deep' : ''}">${info.text}</div>`;

          if (holiday_label) {
            date_text += `<div class="text-alert_deep fs11">${holiday_label}</div>`;
          }

          return { html: `<div class="f fh fclm h36">${date_text}</div>` };
        },

        dayCellContent: (info) => {
          if (this.calendar.view.type !== 'dayGridMonth') return info.dayNumberText;

          const date = new Date(info.date);
          const holiday_label = this.getHolidayLabel(date);

          let date_text = `<div class="${this.isHoliday(date) ? 'text-alert_deep' : ''} text-center">${info.dayNumberText}</div>`;

          if (holiday_label) {
            date_text += `<div class="text-center text-alert_deep fs11">${holiday_label}</div>`;
          }

          return { html: date_text };
        },

        firstDay: 1,

        buttonText: {
          month: '月',
          week: '週',
          day: '日',
        },

        headerToolbar: {
          left: 'custom_today prev icon_calendar title next',

          right: app.useragent.isMobile ? '' : 'timeGridDay,timeGridWeek,dayGridMonth',
        },

        customButtons: {
          icon_calendar: {
            click: () => {
              var modal = spat.modal.open('modal-calendar-mini');
              modal.on('calendarselect', (date) => {
                var view_type = this.getViewType();
                this.calendar.changeView(view_type, date);
                modal.close();
              });
            }
          },

          custom_today: {
            text: '今日',
            click: () => {
              let today = dayjs();
              this.calendar.today();
            }
          }
        },

        views: {
          timeGridDay: {
            titleFormat: (date) => {
              var display_date = dayjs(`${date.start.year}-${date.start.month + 1}-${date.start.day}`);
              return dayjs(display_date).format('YYYY.MM.DD(ddd)');
            },
          },
          timeGridWeek: {
            titleFormat: (date) => {
              return `${date.start.year}.${date.start.month + 1}.${date.start.day} - ${date.end.month + 1}.${date.end.day}`;
            },
          },
          dayGridMonth: {
            dayMaxEvents: 5,

            moreLinkText: function(n) {
              return '他 ' + n + ' 件';
            },
            titleFormat: (date) => {
              return `${date.start.year}.${date.start.month + 1}`
            },
          },
        },

        viewClassNames: () => {

          var view_type = this.calendar.view.type;
          localStorage.setItem('view_type',view_type);
        },

        allDaySlot: false,
        slotDuration: '00:15:00',
        slotLabelInterval: '01:00',
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
          meridiem: 'short'
        },

        events: async (info, successCallback) => {
          successCallback([]);
          await app.utils.wait(128);
          this.trigger('changeview');
        },

        eventChange: async (info) => {
          var record = info.event.extendedProps.record;
          if (!record.data.is_preview) {
            var tooltip = info.event.extendedProps.tooltip;
            await record.refresh();

            var content = record.getTooltipContent();
            tooltip.updateTitleContent(content);
          }
          this.update();
        },

        select: async (info) => {
          if (!spat.popup.getCurrentPopupTag()) {
            setTimeout(() => {
              this.openPopup(info);
            });
          };
          spat.popup.closeAll();

        },

        eventClick: async (info) => {
          var record = info.event.extendedProps.record;

          if (record.data.is_preview || record.isMine()) {
            this.openPopup(info);
          }
          else {
            spat.modal.alert('自分のタスクではないので編集できません');
          }
        },

        eventDrop: async (info) => {

          if (info.jsEvent.altKey) {

            var temp_start_time = info.event.start.getTime();
            var temp_end_time = info.event.end.getTime();

            info.event.setStart(info.oldEvent.start.getTime());
            info.event.setEnd(info.oldEvent.end.getTime());

            var originalRecord = info.event.extendedProps.record;

            this.createRecord({
              title: originalRecord.data.title,
              project_ref: originalRecord.data.project_ref,
              description: originalRecord.data.description || '',
              tags: originalRecord.data.tags,
              start_at: temp_start_time,
              end_at: temp_end_time,
            });
          }
          else {
            var record = info.event.extendedProps.record;

            await app.store.doc(record.path).update({
              start_at: info.event.start.getTime(),
              end_at: info.event.end.getTime(),
            });
            await record.refresh();
          }
        },

        eventResize: async (info) => {
          var record = info.event.extendedProps.record;

          await app.store.doc(record.path).update({
            start_at: info.event.start.getTime(),
            end_at: info.event.end.getTime(),
          });
          await record.refresh();
        },

        eventContent: (info, ce) => {
          var $elm = document.createElement(`div`);

          var record = info.event.extendedProps.record || info.event.extendedProps.template;
          var riotTag = riot.mount($elm, 'atom-task', {record})[0];
          var html = riotTag.root.innerHTML;
          riotTag.unmount();

          return {
            html: html,
          };
        },

        eventReceive: async (info) => {

          info.revert();

          var template = info.event.extendedProps.template;

          var record = await this.createRecord({
            title: template.data.title,
            project_ref: template.relation.project ? template.relation.project.ref : null,
            tags: template.data.tags,
            start_at: info.event.start.getTime(),
            end_at: info.event.end.getTime(),
          });

          this.calendar.unselect();
        },

        eventDidMount: (info) => {

          if (info.event.extendedProps.template || info.isDragging || info.isResizing) return;

          var record = info.event.extendedProps.record;
          var content = '';

          if (!record.data.is_preview) {
            content = record.getTooltipContent();
          }
          else {
            content = record.data.title + '\n' + `${dayjs(record.data.start_at).format('HH:mm')} - ${dayjs(record.data.end_at).format('HH:mm')}`;
          }

          var tooltip = new Tooltip(info.el, {
            title: content,
            placement: 'top-start',
            trigger: 'hover',
            container: 'body',

          });
          info.event.setExtendedProp('tooltip', tooltip);

        },

      });
      this.calendar = calendar;

      calendar.render();

      this.addCalendarIcon();
    };

    this.fetchEvents = async (user, project) => {
      this.calendar.removeAllEvents();

      var start_threshold = dayjs(this.calendar.view.activeStart.getTime()).subtract(1, "d").valueOf();
      var where_items = [
        ['start_at', '>=', start_threshold],
        ['start_at', '<=', this.calendar.view.activeEnd.getTime()],
      ];

      if (user) {
        var select_user = this.opts.users.find(u => u.id === user.id);
        where_items.push(['created_user_ref', '==', select_user.ref]);
      }

      if (project && project !== "未設定") {
        var select_project = this.opts.projects.find(u => u.id === project.id);
        where_items.push(['project_ref', '==', select_project.ref]);
      }

      if (project === "未設定") {
        where_items.push(['project_ref', '==', null]);
      }

      var ref = app.store.collection('records');
      where_items.forEach(w => {
        ref = ref.where(...w);
      });
      var records = await ref.fetch({ relation: true });

      records = records.filter(r => !r.isMine() || !r.data.is_recording && r.isMine());

      this.calendar.batchRendering(() => {
        records.forEach(item => {
          this.recordToEvent(item);
        });
      });

      var active_record = await app.store.collection('records')
        .where('is_recording', '==', true)
        .where('created_user_ref', '==', app.store.currentUser.ref)
        .fetch({ relation: true });

      this.activeRecord = active_record[0];
      if (this.activeRecord) {
        this.recordToEvent(this.activeRecord);
      }
      this.trigger('setupactiverecord', this.activeRecord);

      this.update();
    };

    this.createRecord = async ({ title, project_ref, description = '', tags, start_at, end_at }) => {
      var ref = await app.store.collection('records').add({
        title,
        project_ref,
        description,
        tags: tags ? tags : [],
        start_at,
        end_at,
        is_recording: false,
        created_user_ref: app.store.currentUser.ref,
        created_at: Date.now(),
        updated_at: Date.now(),
      });
      var record = await app.store.doc(ref.path).fetch({ relation: true });

      this.recordToEvent(record);

      return record;
    };

    this.recordToEvent = (record) => {
      var is_mine;
      var color;
      var classNames = ['rounded-8'];

      if (!record.data.is_preview) {
        is_mine = record.isMine();
        color = record.getColor();
      }
      else {
        is_mine = true;
        color = '#0070FF';
        classNames.push('opacity-60');
      }

      if (record.data.is_recording) classNames.push('border-dashed bg-white');

      if (!is_mine) classNames.push('opacity-60');

      var editable = !record.data.is_preview && !record.data.is_recording && is_mine;

      var event = this.calendar.addEvent({
        id: record.id,
        title: record.data.title,
        start: new Date(record.data.start_at),
        end: record.data.end_at ? new Date(record.data.end_at) : Date.now(),
        allDay: false,
        editable: editable,
        backgroundColor: color + '0D',
        borderColor: color,
        textColor: '#2E2E38',
        classNames: classNames,
        extendedProps: {
          record: record,
        },
      });

      this.trigger('refresh');

      return event;
    };

    this.deleteCalendar = () => {
      this.calendar.destroy();
      delete this.calendar;
    };

    this.openPopup = async (info) => {
      info.jsEvent.preventDefault();
      var record = info.event ? info.event.extendedProps.record : '';
      let is_preview = record ? record.data.is_preview : false;

      if (is_preview) {
        await this.setProjectFromHistory(record);
      }

      var item = {
        record: record,
        start_at: record ? record.data.start_at : info.start.getTime(),
        end_at: record ? record.data.end_at : info.end.getTime(),
        is_preview,
      };

      var popup = spat.popup.open('popup-record-edit', {

        offsetTop: info.jsEvent.clientY + 12,
        offsetLeft: info.jsEvent.clientX + 12,
        closeTarget: this.root,
        opener: this.root,
        position: 'bottom',
        opts: {
          item: item,
        },
      }).on("create", ({data}) => {
        this.createRecord({
          title: data.title,
          project_ref: data.project ? data.project.ref : null,
          description: data.description || '',
          tags: data.tags,
          start_at: data.start_at,
          end_at: data.end_at,
        });
        this.trigger('refresh');
      }).on('submit', async ({data}) => {
        await record.update({
          title: data.title,
          project_ref: data.project ? data.project.ref : null,
          description: data.description || '',
          tags: data.tags,
          updated_at: Date.now(),
          start_at: data.start_at,
          end_at: data.end_at,
        });
        await record.refresh();
        var updatedRecord = await record.fetch({ relation: true });

        info.event.setProp('title', updatedRecord.data.title);
        info.event.setProp('backgroundColor', updatedRecord.getColor() + '0D');
        info.event.setProp('borderColor', updatedRecord.getColor());
        info.event.setStart(updatedRecord.data.start_at);
        info.event.setEnd(updatedRecord.data.end_at);

        info.event.setExtendedProp('record', updatedRecord);
        this.trigger('refresh');
      }).on('delete', async () => {
        var result = await spat.modal.confirm('削除しますか？');
        if (!result) return;
        app.store.doc(record.path).delete();

        info.event.extendedProps.tooltip.dispose();
        info.event.remove();
        this.trigger('refresh');
      }).on('startrecorder', (item, info) => {
        this.bubbleTrigger('startrecorder', item);
        popup.close();
      });
    };

    this.setProjectFromHistory = async (record) => {
      let histories = await app.store.collection('records')
        .where('created_user_ref', '==', app.store.currentUser.ref)
        .orderBy('created_at', 'desc')
        .limit(128)
        .fetch({ relation: true });

      var history = histories.find(h => h.data.title === record.data.title);

      if (history && history.data.project_ref) {
        record.relation = {};
        record.data.project_ref = history.data.project_ref;
        record.relation.project = history.relation?.project;
      }
    };

    this.getViewType = () => {
      return localStorage.getItem('view_type') || 'timeGridDay';
    };

    this.addCalendarIcon = () => {
      var $ele = this.root.getElementsByClassName('fc-icon_calendar-button')
      $ele[0].classList.add('icon-calendar');
    };

    this.getHolidayLabel = (date) => {
      let holiday = app.holidayJp.between(date, date)[0];
      if (holiday) {
        return holiday.name;
      }
      return "";
    };

    this.isHoliday = (date) => {
      return app.holidayJp.isHoliday(date);
    };
});